module.exports = __webpack_public_path__ + "media/dog-personality-traits/cookie-8f0b4c9c.svg";